function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import mainNav from './HamburgerNav';
import { appActions } from '../../reducers/app.reducer';
import HamburgerItem from './HamburgerItem.react';
var Hamburger = function Hamburger() {
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useState3 = useState(1024),
    _useState4 = _slicedToArray(_useState3, 1),
    bp = _useState4[0];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    visible = _useState6[0],
    setVisible = _useState6[1];

  // Redux hooks
  var dispatch = useDispatch();
  var toggleHamburgerMenu = useSelector(function (s) {
    return s.app.toggleHamburgerMenu;
  });
  // TODO :: this should not be ||
  var userPermissions = useSelector(function (s) {
    var _s$auth, _s$auth$user;
    return ((_s$auth = s.auth) === null || _s$auth === void 0 ? void 0 : (_s$auth$user = _s$auth.user) === null || _s$auth$user === void 0 ? void 0 : _s$auth$user.permissions) || [];
  });

  // Router hook
  var location = useLocation();
  var pathname = location.pathname;

  // Action dispatcher
  var toggleHamburgerMenuAction = function toggleHamburgerMenuAction(value) {
    dispatch(appActions.toggleHamburgerMenu(value));
  };

  // TODO :: better logic for this, use animate for overlay
  var open = function open() {
    $("#".concat(id)).addClass('hamburger__open');
    if ($(window).width() <= bp) {
      $("#".concat(id, "overlay")).addClass('hamburger__overlay--visible');
      setTimeout(function () {
        $('.hamburger__overlay--visible').css({
          opacity: 1
        });
      }, 100);
    } else {
      $('.app').addClass('app__sidebar-open');
    }
  };
  var close = function close() {
    $("#".concat(id)).removeClass('hamburger__open');
    $('.hamburger__overlay--visible').css({
      opacity: 0
    });
    setTimeout(function () {
      $("#".concat(id, "overlay")).removeClass('hamburger__overlay--visible');
    }, 600);
    $('.app').removeClass('app__sidebar-open');
  };
  useEffect(function () {
    var onResize = function onResize() {
      if ($(window).width() > bp) setVisible(true);else setVisible(false);
    };
    $(window).on('resize', onResize);
    setTimeout(onResize, 1000);
    return function () {
      return $(window).off('resize', onResize);
    };
  }, [bp]);
  useEffect(function () {
    if (visible) open();else close();
  }, [visible, id, bp]);
  useEffect(function () {
    if ($(window).width() > bp || visible === null) return;
    setVisible(!visible);
  }, [toggleHamburgerMenu, bp, visible]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hamburger",
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "hamburger__logo"
  }, /*#__PURE__*/React.createElement(NavLink, {
    to: "/"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/posillico-cms-logo.png",
    alt: "Posillico CMS Logo"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hamburger__content"
  }, mainNav.map(function (x) {
    if (!x.published) return null;
    if (x.permission && !userPermissions.find(function (y) {
      return y.key === x.permission && y.value === true;
    })) return null;
    return /*#__PURE__*/React.createElement(HamburgerItem, _extends({}, x, {
      pathname: pathname,
      key: x.title
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hamburger__overlay",
    id: "".concat(id, "overlay"),
    onClick: function onClick() {
      toggleHamburgerMenuAction(false);
    }
  }));
};
export default Hamburger;